import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AccessMenuService } from '@fuse/services/access-menu.service';
import { ValidacionsesionService } from 'app/validacionsesion/validacionsesion.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private validacionsesion: ValidacionsesionService,
        private accessMenuService: AccessMenuService,
        private router: Router) { }

        canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
            const sessionData = JSON.parse(window.localStorage.getItem('data'));
            const currentTabId = sessionStorage.getItem('tabId') || this.generateTabId();
        
            sessionStorage.setItem('tabId', currentTabId);
            localStorage.setItem('activeTab', currentTabId);
        
            const activeTab = localStorage.getItem('activeTab');
        
            if (sessionData && activeTab !== currentTabId) {
                const confirmClose = confirm(
                    'Ya tienes una sesión iniciada en otra pestaña. ¿Deseas cerrar la sesión activa y continuar aquí?'
                );
        
                if (!confirmClose) {
                    return false;
                }
        
                localStorage.setItem('activeTab', currentTabId);
            }
        
            if (!sessionData) {
                localStorage.setItem('returnUrl', state.url);
                localStorage.removeItem('session-active');
                this.router.navigate(['login']);
                return false;
            }
        
            const redirectUrl = route.queryParams['redirect'];
            if (redirectUrl) {
                const decodedUrl = decodeURIComponent(redirectUrl);
                console.log('🔄 Redirigiendo a:', decodedUrl);
        
                setTimeout(() => {
                    window.location.href = decodedUrl;
                }, 100);
        
                return false;
            }
        
            const horacerrarsesion = new Date().getTime();
            // const horageneral = 0; 
            const horageneral = 1 * 60 * 60 * 1000;
            const horaensesion = horacerrarsesion - sessionData.loginTime;
        
            if (horaensesion > horageneral) {
                window.localStorage.removeItem('data');
                localStorage.removeItem('session-active');
                this.router.navigate(['login']);
                alert('Sesión expirada, por favor inicia sesión nuevamente.');
                return false;
            }
        
            const isRouteAllowed = (menu: any[], route: string): boolean => {
                for (const item of menu) {
                    if (item.url === route) {
                        return true;
                    }
                    if (item.children && item.children.length > 0) {
                        if (isRouteAllowed(item.children, route)) {
                            return true;
                        }
                    }
                }
                return false;
            };
        
            const currentRoute = state.url;
            const isMenuAllowed = isRouteAllowed(this.accessMenuService.listMenu, currentRoute);
        
            if (isMenuAllowed) {
                return true;
            } else {
                const returnUrl = localStorage.getItem('returnUrl');
        
                if (returnUrl && isRouteAllowed(this.accessMenuService.listMenu, returnUrl)) {
                    localStorage.removeItem('returnUrl');
                    this.router.navigateByUrl(returnUrl);
                } else {
                    this.router.navigate(['/dashboard']);
                }
        
                return false;
            }
        }
        



    private generateTabId(): string {
        return `${new Date().getTime()}-${Math.random()}`;
    }



}
